export interface AnnouncementArgument {
  id: string
  title: string
  content: string
  link?: string
  challengeID?: string
  videoUrl?: string
  fullscreen?: boolean
  createdAt: Date
}

export default class Announcement {
  readonly id: string
  readonly title: string
  readonly content: string
  readonly link?: string
  readonly challengeID?: string
  readonly videoUrl?: string
  readonly fullscreen: boolean
  readonly createdAt: Date

  constructor(arg: AnnouncementArgument) {
    this.id = arg.id
    this.title = arg.title
    this.content = arg.content
    this.link = arg.link
    this.challengeID = arg.challengeID
    this.videoUrl = arg.videoUrl
    this.fullscreen = arg.fullscreen ?? false
    this.createdAt = new Date(arg.createdAt)
  }

  static fromPG(data: any): Announcement {
    return new Announcement({
      id: data.id,
      title: data.title,
      content: data.content,
      link: data.link ?? undefined,
      challengeID: data.challenge_id ?? undefined,
      videoUrl: data.video_url ?? undefined,
      fullscreen: data.fullscreen ?? false,
      createdAt: data.created_at,
    })
  }

  toPG() {
    return {
      id: this.id,
      title: this.title,
      content: this.content,
      link: this.link ?? null,
      challenge_id: this.challengeID ?? null,
      video_url: this.videoUrl ?? null,
      fullscreen: this.fullscreen,
      created_at: this.createdAt,
    }
  }
}
